var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('AuthMenubar'),_c('div',{staticClass:"main-wrapper"},[(_vm.$store.state.menuExpanded)?_c('MobileMenu'):_vm._e(),_c('main',{class:{'mobile-menu-expanded': _vm.$store.state.menuExpanded}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }